import { Styles } from '@monkvision/types';

const SMALL_SCREEN__BREAKPOINT_PX = 650;
const HEADER_HEIGHT_PX = 130;
const MODAL_PADDING = '1rem';
export const VEHICLE360_WIDTH_PX = 500;

export const styles: Styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    width: '100%',
    height: '100%',
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  vehicle360: {
    width: `${VEHICLE360_WIDTH_PX}px`,
    position: 'absolute',
    padding: '0px 5px 0 35px',
  },
  vehicle360SmallScreen: {
    __media: { maxWidth: SMALL_SCREEN__BREAKPOINT_PX },
  },
  gallery: {
    width: `calc(100% - ${VEHICLE360_WIDTH_PX}px - ${MODAL_PADDING})`,
    position: 'absolute',
    height: `calc(100% - ${HEADER_HEIGHT_PX}px)`,
    overflow: 'auto',
    right: 0,
    paddingRight: '20px',
  },
  header: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  menu: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 55px 10px 55px',
  },
  switchButton: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    alignItems: 'center',
  },
  generatePDFContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    padding: '0 10px',
  },
  v360: {
    height: '400px',
  },
  downloadPicturesButton: {
    padding: '5px 0px',
  },
};
